<template>
  <div class="h-full">
    <component :is='componentView'
      :component='component'
      :transform='transform'
      :transforms-and-source='transformsAndSource'
      :partutil='partutil'
      :is-selected-component='isSelectedComponent'
      :disable-toolbar-buttons='disableToolbarButtons'
       class='h-full flex flex-col'
      @change="onChange"
      @add='$emit("add", $event)'
      @move-to='$emit("move-to", $event)'
      @remove='$emit("remove", $event)'
      @validated="onValidated"
      @autofinish='onAutoFinish' 
      >
      <template #recommend='{}'>
        <slot name='recommend' />
      </template>
    </component>

  </div>

</template>
<script>
import * as EditingComponentMapping from '@components/editing/editingComponentMapping.js';
import InlineRender from '@edit/atoms/InlineRender.vue';
import GameVariables from '@edit/tree/gamevariables.js';
import Close from '@icons/Close.vue';
import Fullscreen from '@icons/Fullscreen.vue';
import FullscreenExit from '@icons/FullscreenExit.vue';
import ChevronRight from '@icons/ChevronRight.vue';

export default {
  props: {
    transform: {
      type: Object,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    isSelectedComponent: {
      type: Boolean,
      default: false
    },
    disableToolbarButtons: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const gameVariables = new GameVariables(this.transformsAndSource.gamedata);
    const variables = gameVariables.getVariablesForTransform(this.transformsAndSource, this.transform);
    return {
      variables,
    }
  },
  components: {
    InlineRender,
    Close,
    Fullscreen,
    ChevronRight
  },
  methods:{
    onChange({nv,ov}) {
      this.$emit('change', {nv,ov});
    },
    onValidated(nv) {
      this.$emit('validated', nv);
    },
    onAutoFinish() {
      this.$emit('autofinish');
    }
  },
  computed: {
    componentView() {
      let componentView = EditingComponentMapping.default[this.component.type];
      if (!componentView) {
        componentView = EditingComponentMapping.default.generic;
      }
      return componentView;
    },
  },
  watch:{
    'transform.variables.length'() {
      const gameVariables = new GameVariables(this.transformsAndSource.gamedata);
      this.$set(this, 'variables', gameVariables.getVariablesForTransform(this.transformsAndSource, this.transform));
    },
  }
}
</script>
